import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AdminNavbar from '../Components/AdminSidebar';

import { FaUsers } from 'react-icons/fa';

const MarketingMembers = () => {
  const [members, setMembers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchMembers();
  }, []);

 const fetchMembers = async () => {
  try {
    const res = await axios.get(
      'https://missionmap-lc.onrender.com/api/marketing-report/members',
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }
    );

    setMembers(res.data.members);
  } catch (err) {
    console.error(err);
  }
};

  const handleViewReports = (memberId) => {
   navigate(`/marketing-reports/${memberId}`);
  };

  return (
   <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 md:p-6">
        <AdminNavbar />
     

      <div className="flex-1 p-4 md:p-6">
      

        {/* Header */}
        <div className="mb-8 flex justify-between items-center">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-800 flex items-center gap-2">
              <FaUsers className="text-green-600" />
              Marketing Team Members
            </h1>
            <p className="text-gray-600 mt-2">
              View all marketing role members in your company
            </p>
          </div>

          <button
            onClick={() => navigate("/admin-report")}
            className="flex items-center gap-2 px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-900 transition"
          >
            ← Back
          </button>
        </div>

        {/* Members Grid */}
        <div className="bg-white rounded-2xl shadow-lg p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {members.map((member) => (
              <div
                key={member._id}
                className="bg-gray-50 rounded-2xl shadow-md p-5 hover:shadow-xl transition duration-300"
              >
                <div className="flex flex-col items-center text-center">
                  <img
                    src={
                      member.profileImage ||
                      'https://cdn-icons-png.flaticon.com/512/149/149071.png'
                    }
                    alt="profile"
                    className="w-20 h-20 rounded-full object-cover mb-4 border"
                  />

                  <h2 className="text-lg font-semibold text-gray-800">
                    {member.username}
                  </h2>

                  <p className="text-sm text-gray-500">{member.email}</p>

                  <p className="text-xs text-gray-400 mt-1">
                    Team: {member.team || 'N/A'}
                  </p>

                  <span
                    className={`mt-2 text-xs px-3 py-1 rounded-full ${
                      member.workMode === 'Remote'
                        ? 'bg-blue-100 text-blue-600'
                        : 'bg-green-100 text-green-600'
                    }`}
                  >
                    {member.workMode}
                  </span>

                  <button
                    onClick={() => handleViewReports(member.username)}
                    className="mt-4 px-4 py-1.5 bg-green-600 text-white rounded-lg text-sm hover:bg-green-700 transition"
                  >
                    View Reports
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default MarketingMembers;